import {Component} from '@angular/core';
import {DocumentsService} from '../../../services/documents.service';

@Component({
    selector: 'directory-path',
    templateUrl: './directory-path.component.html',
    styleUrls: ['./directory-path.component.scss']
})
export class DirectoryPathComponent {

    constructor(public ds: DocumentsService) {
    }

    public goTo(documentId) {
        this.ds.goTo(documentId);
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/documents/directory-path/directory-path.component.ts